import type { TQuestionAnswer } from '$/types/components/questions';

export enum Diploma {
  ABITUR = 28,
  PROFESSIONAL_DIPLOMA = 29,
  OTHER_TRAINING = 30,
}

export enum DiplomaName {
  ABITUR = 'Abitur',
  PROFESSIONAL_DIPLOMA = 'Fachabitur',
  OTHER_TRAINING = 'Andere Ausbildung',
}

const diplomasList: TQuestionAnswer<Diploma>[] = [
  { id: Diploma.ABITUR, value: DiplomaName.ABITUR },
  { id: Diploma.PROFESSIONAL_DIPLOMA, value: DiplomaName.PROFESSIONAL_DIPLOMA },
  { id: Diploma.OTHER_TRAINING, value: DiplomaName.OTHER_TRAINING },
];

export default diplomasList;
